export default __webpack_public_path__ + "static/style4.4_Elena-3b78500dba27a678420018c7ccb01248.wav";